import React from "react";
import MultiSelectCalloutWithSearch, { IMultiSelectButtonStyle } from "./forms/inputs/multiSelectCalloutWithSearch";
import { IdNamePair } from "../models";
import { Button } from "@mui/material";

interface IAudienceSearchCalloutProps {
    availableAudienceIdNames: IdNamePair<string, string>[];
    selectedOptions: IdNamePair<string, string>[];
    onAudienceFilterChange: (newAudiences: IdNamePair<string, string>[]) => void;
    buttonStyle?: IMultiSelectButtonStyle;
}

const AudienceSearchCallout: React.FC<IAudienceSearchCalloutProps> = ({
    availableAudienceIdNames,
    selectedOptions,
    onAudienceFilterChange,
    buttonStyle
}) => {
    return <MultiSelectCalloutWithSearch
        defaultOptions={availableAudienceIdNames}
        selectedOptions={selectedOptions}
        onChange={onAudienceFilterChange}
        buttonStyle={buttonStyle}
        searchBarText="Search audience"
        footerComponent={
            <div>
                <Button
                    color="primary"
                    style={{ float: "right" }}
                    onClick={() => onAudienceFilterChange([])}
                >
                    Clear All
                </Button>
            </div>
        }
        nestingAllowed={false}
        buttonId="audience-search-callout"
    />
};

export default AudienceSearchCallout;
